// extracted by mini-css-extract-plugin
export default {"referee__competitions":"competitions-list_referee__competitions__HnB+X","referee__competitions_card":"competitions-list_referee__competitions_card__hHirB"};